<div>
  {{ uiService.productName }} used S3 batch operations to copy existing objects from your primary environment bucket to
  your recovery environment bucket. {{ failedPercentage }}% of those copy operations were unsuccessful.
</div>
<div class="margin-top">
  To avoid excess AWS expense, {{ uiService.productName }} will not retry these copy operations.
</div>
<div class="margin-top">
  You can review the following S3 batch logs to identify failed object copies and retry these operations yourself.
  <ul>
    @for (log of failedLogFiles; track log) {
      <li>{{ log }}</li>
    }
  </ul>
</div>

<div class="flex-center-row control-header">
  <div class="spacer"></div>
  <button class="arpio-button" (click)="acknowledgeIssue()">Acknowledge</button>
</div>
